import { render, staticRenderFns } from "./BasePlayablesList.vue?vue&type=template&id=79d77c3e&scoped=true&"
import script from "./BasePlayablesList.vue?vue&type=script&lang=js&"
export * from "./BasePlayablesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d77c3e",
  null
  
)

component.options.__file = "BasePlayablesList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
installComponents(component, {
  VDivider,
  VList,
})
